import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Duplicate = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Duplicate' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M4.5,17 L1,17 L1,1 L1,1 L17,1 L17,4.5 M7,7 L23,7 L23,23 L7,23 L7,7 Z M15,11 L15,19 L15,11 Z M11,15 L19,15 L11,15 Z' />
  </StyledIcon>
);
